import { Navigate } from "react-router";

import { useScopeParams } from "@/hooks/useScopeParams";
import { getFirstAvailableMenuPath } from "@/utils/landingPageUtils";
import {
  getAdminLandingMenuItems,
  useAdminFeatureAvailability,
} from "@/hooks/useAdminNavigation";

export default function AdminLandingRedirect() {
  const { buildUrl } = useScopeParams();
  const { hasAdminAccess } = useAdminFeatureAvailability();
  const firstAvailablePath = getFirstAvailableMenuPath(
    getAdminLandingMenuItems(),
  );

  if (!hasAdminAccess) {
    return <Navigate to="/403" replace />;
  }

  if (firstAvailablePath === "/404") {
    return <Navigate to="/404" replace />;
  }

  return (
    <Navigate to={buildUrl(firstAvailablePath.replace(/^\//, ""))} replace />
  );
}
